import { CoreAPI, createCommonOrgMethods } from '@hero/sdk-core';

/**
 * Carrier-facing `Org` APIs (post relations-v2). Same single-collection
 * model as the customer SDK — every business / carrier / broker org
 * is exposed through the unified `Org` resource here. Read-only;
 * writes still flow through unified signup and the role-agnostic
 * `organization.update-profile` endpoint.
 */
export function createOrgsAPI(coreAPI: CoreAPI) {
  return {
    ...createCommonOrgMethods(coreAPI),
  };
}
